import React from 'react';
import { Typography } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants } from '../../utils/useAnimations';

const { Paragraph } = Typography;

export const CtaBanner: React.FC = () => {
  return (
    <section className="bg-primary-600 text-center py-8 mt-10">
      <motion.div
        variants={standardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <Paragraph className="!text-neutral-white !mb-0 !text-2xl !font-semibold"> 
          Une expérience immersive pour comprendre l'importance de l'accessibilité numérique.
        </Paragraph>
      </motion.div>
    </section>
  );
};